import { Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { ButtonComponent } from '@gfe/shared/components/button/button.component';

export interface PlanDetails {
  name: string;
  description: string;
}

/**
 * Name and description form shared by the flows that set them (duplicate, rename). The
 * limits match GBE's validation for both routes.
 */
@Component({
  selector: 'app-plan-details-form',
  imports: [ReactiveFormsModule, TranslatePipe, ButtonComponent],
  templateUrl: './plan-details-form.component.html',
  styles: ``
})
export class PlanDetailsFormComponent {
  private readonly fb = inject(FormBuilder);

  initialName = input<string>('');
  initialDescription = input<string>('');
  submitLabel = input.required<string>();
  submitIcon = input.required<string>();
  submitting = input<boolean>(false);

  submitted = output<PlanDetails>();
  closeModal = output();

  protected readonly form = this.fb.group({
    name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
    description: ['', [Validators.maxLength(500)]]
  });

  private prefilled = false;

  constructor() {
    // Pre-filled once only: a later input change must not wipe what the user typed.
    effect(() => {
      const name = this.initialName();
      const description = this.initialDescription();
      if (this.prefilled) {
        return;
      }
      this.form.setValue({ name: name ?? '', description: description ?? '' });
      this.prefilled = true;
    });
  }

  protected onSubmit(): void {
    if (this.form.invalid) {
      return;
    }
    this.submitted.emit({
      name: this.form.value.name ?? '',
      description: this.form.value.description ?? ''
    });
  }

  protected onCancel(): void {
    this.closeModal.emit();
  }
}
